import moment from "moment";
import { useEffect, useMemo, useState } from "react";

import { HashLink } from "react-router-hash-link";
import { useUser } from "../../../../providers/user";
import { IAppointmentInternal } from "../../../../providers/user/types";

import ConsultaCard from "../../../../components/Cards/ConsultaCard";
import ConsultaCardSkeleton from "../../../../components/Skeletons/ConsultaCardSkeleton";
import { usePartnerData } from "../../../../providers/partnerData";

const PastAppointmentsList = () => {
  const pastTime = 1;
  const [isLoading, setIsLoading] = useState(true);
  const { pastAppointments, getAppointments } = useUser();
  const { partnerUrl } = usePartnerData();


  const sortedAppointments = useMemo(() => {
    // Primeiro filtra appointments válidos, depois ordena
    const validAppointments = pastAppointments.filter(
      (appointment) => appointment.specialistDoctor !== null && appointment.specialistDoctor !== undefined
    );

    return validAppointments.sort(
      (firstItem: IAppointmentInternal, secondItem: IAppointmentInternal) =>
        moment(firstItem.date)
          .add(firstItem.scheduleTime.initialTimeHours, "hour")
          .add(firstItem.scheduleTime.initialTimeMinutes, "minute") >
          moment(secondItem.date)
            .add(secondItem.scheduleTime.initialTimeHours, "hour")
            .add(secondItem.scheduleTime.initialTimeMinutes, "minute")
          ? 1
          : -1
    );
  }, [pastAppointments]);

  useEffect(() => {
    getAppointments(pastTime).then(() => setIsLoading(false));
  }, []);

  return (
    <>
      {isLoading && [...Array(3)].map((_, index) => <ConsultaCardSkeleton key={index} />)}
      {!isLoading && (<>

        {!sortedAppointments.length && (
          <div className="text-center text-muted">
            <p className="mb-0">
              <i className="las la-calendar-times display-4"></i>
            </p>
            <h6>Você não realizou nenhuma consulta</h6>
            <p>
              <HashLink
                smooth
                to={`/${partnerUrl}#listagem`}
                className="btn btn-primary"
              >
                Listar Profissionais
              </HashLink>
            </p>
          </div>
        )}

        {(sortedAppointments.length > 0) &&
          sortedAppointments.map((appointment) => (
            <ConsultaCard
              key={appointment.id}
              appointment={appointment}
              isPastAppointment
            />
          )
          )}
      </>)}
    </>
  );
};

export default PastAppointmentsList;
